import {LavoratorePresenzeRecord} from "@commons/mapping/LavoratorePresenzeRecord";
import {PresenzeGiornataPlusRecord} from "@commons/mapping/PresenzeGiornataPlusRecord";
import {GiustificativoRecord, GruppoEventi} from "@commons/mapping/GiustificativoRecord";
import {GiuFormValues, PresenzeGiustificativoEx} from "../localMapping/PresenzeGiustificativoEx";
import React from "react";
import {useFieldArray} from "react-hook-form";
import {EditGiustificativi} from "./EditGiustificativi";

interface EditGiustificativiPannelloGPLUSProps {
    lavoratore: Pick<LavoratorePresenzeRecord, 'causaliWF' | 'status'>,
    day: PresenzeGiornataPlusRecord,
    giustificativi: GiustificativoRecord[],
    gruppiEventi?: GruppoEventi,
    labelClassName?: string,
    giuClassName?: string,
    quantitaOrarieIn?: 'CENTESIMI' | 'MINUTI',
    onChange?: (causali: PresenzeGiustificativoEx[]) => void,
}

export const EditGiustificativiHH: React.FC<EditGiustificativiPannelloGPLUSProps> = (props) => {
    const useField = useFieldArray<GiuFormValues, 'giustificativiHHGiornata' | 'giustificativiQIGiornata'>(
        {
            name: 'giustificativiHHGiornata',
            rules: {validate: () => true}
        });

    return <EditGiustificativi {...props} showRange={false} showLabel={false} name={'giustificativiHHGiornata'} useFieldArrayReturn={useField}></EditGiustificativi>;
}

export const EditGiustificativiQI: React.FC<EditGiustificativiPannelloGPLUSProps> = (props) => {
    const useField = useFieldArray<GiuFormValues, 'giustificativiHHGiornata' | 'giustificativiQIGiornata'>(
        {
            name: 'giustificativiQIGiornata',
            rules: {validate: () => true}
        });

    return <EditGiustificativi {...props} showRange={false} showLabel={false} name={'giustificativiQIGiornata'} useFieldArrayReturn={useField}></EditGiustificativi>;
}